module.exports = __webpack_public_path__ + "img/hehua.8b896bb5.png";